/* eslint-disable no-restricted-imports */
import * as colors from './tokens-dist/ts/colors';

/**
 * Token exports
 */
const tokens = {
  colors,
};

export { tokens };
